// Conecta el selector visual de bundle (1/2/3 lámparas) con el input de
// cantidad real del formulario de producto (Dawn nativo), para que el
// carrito, las reglas de cantidad y el descuento automático de Shopify
// sigan siendo la única fuente de verdad del precio.
(function () {
  // cantidadActiva[sectionId] = último número de bundle elegido por el
  // comprador. Sirve de respaldo: justo antes de agregar al carrito, se
  // vuelve a forzar este valor en el input real — así, aunque algún
  // navegador (Safari es el caso conocido) no asocie bien un <input> que
  // vive fuera del <form> vía el atributo form="", el número correcto
  // siempre llega al carrito.
  var cantidadActiva = {};

  function activar(bundle) {
    var sectionId = bundle.dataset.section;
    var input = document.getElementById('Quantity-' + sectionId);
    if (!input) return;

    cantidadActiva[sectionId] = input.value || '1';

    bundle.querySelectorAll('[data-tz-bundle-opcion]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        var cantidad = boton.dataset.cantidad;
        cantidadActiva[sectionId] = cantidad;

        bundle.querySelectorAll('[data-tz-bundle-opcion]').forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-checked', 'false');
        });
        boton.classList.add('is-selected');
        boton.setAttribute('aria-checked', 'true');

        input.value = cantidad;
        input.setAttribute('value', cantidad);
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new Event('input', { bubbles: true }));

        document.dispatchEvent(
          new CustomEvent('tz:bundle_selected', {
            detail: { cantidad: cantidad, sectionId: sectionId },
          })
        );
      });
    });

    // Respaldo: justo antes de que se agregue al carrito (clic real, no
    // solo el evento "change"), se reafirma la cantidad elegida.
    var formulario = input.form || document.getElementById(input.getAttribute('form'));
    if (formulario) {
      formulario.addEventListener(
        'submit',
        function () {
          input.value = cantidadActiva[sectionId];
        },
        true
      );
    }
    document.addEventListener(
      'click',
      function (evento) {
        var esAgregar = evento.target.closest(
          'button[name="add"], [data-tz-comprar-ahora]'
        );
        if (!esAgregar) return;
        if (formulario && !formulario.contains(esAgregar) && esAgregar.closest('form') !== formulario) return;
        input.value = cantidadActiva[sectionId];
      },
      true
    );
  }

  document.querySelectorAll('[data-tz-bundle]').forEach(activar);

  // Vista rápida del regalo: muestra la foto 5 s y se cierra sola, sin salir de la página.
  var visor = null;
  var temporizador = null;
  var origen = null;

  function cerrarVisor() {
    clearTimeout(temporizador);
    if (!visor) return;
    var caja = visor;
    visor = null;
    caja.classList.remove('is-visible');
    document.removeEventListener('keydown', alTeclear);
    setTimeout(function () { caja.remove(); }, 250);
    if (origen) origen.focus();
  }

  function alTeclear(evento) {
    if (evento.key === 'Escape') cerrarVisor();
  }

  function abrirVisor(boton) {
    if (visor) return;
    origen = boton;
    var imagen = boton.getAttribute('data-imagen');
    if (!imagen) return;
    visor = document.createElement('div');
    visor.className = 'tz-regalo-visor';
    visor.setAttribute('role', 'dialog');
    visor.setAttribute('aria-label', 'Regalo incluido');
    visor.innerHTML =
      '<div class="tz-regalo-visor__caja">' +
      '<img alt="">' +
      '<p class="tz-regalo-visor__etiqueta">🎁 Tu regalo al comprar 2 o más</p>' +
      '<div class="tz-regalo-visor__barra"></div>' +
      '<button type="button" class="tz-regalo-visor__cerrar" aria-label="Cerrar">&times;</button>' +
      '</div>';
    var foto = visor.querySelector('img');
    foto.src = imagen;
    foto.alt = boton.getAttribute('data-alt') || '';
    visor.addEventListener('click', cerrarVisor);
    document.body.appendChild(visor);
    document.addEventListener('keydown', alTeclear);
    requestAnimationFrame(function () { visor && visor.classList.add('is-visible'); });
    temporizador = setTimeout(cerrarVisor, 5000);
  }

  document.addEventListener('click', function (evento) {
    var boton = evento.target.closest('[data-tz-regalo-ver]');
    if (boton) abrirVisor(boton);
  });
})();
